module.exports = __webpack_public_path__ + "static/img/pair-sketch.0b04e803.svg";